export default __webpack_public_path__ + "static/GT-America-Extended-Bold-4af5500e51d1a13da8afa38a0a4a9f07.woff2";